import { render, staticRenderFns } from "./AssetVideoGenerationSettings.vue?vue&type=template&id=4533d48a&lang=pug"
import script from "./AssetVideoGenerationSettings.vue?vue&type=script&lang=js"
export * from "./AssetVideoGenerationSettings.vue?vue&type=script&lang=js"
import style0 from "./AssetVideoGenerationSettings.vue?vue&type=style&index=0&id=4533d48a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports